import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// Components
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ProfileLoggedOutComponent } from './components/profile/profile-logged-out/profile-logged-out.component';
import { SubscriptionLoggedOutComponent } from './components/subscription/subscription-logged-out/subscription-logged-out.component';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { HelpComponent } from './components/help/help.component';
import { HelpLoggedOutComponent } from './components/help/help-logged-out/help-logged-out.component';
import { ManagePaymentMethodComponent } from './components/subscription/manage-payment-method/manage-payment-method.component';
import { AddNewCreditCardComponent } from './components/subscription/add-new-credit-card/add-new-credit-card.component';
import { AddNewBankAccountComponent } from './components/subscription/add-new-bank-account/add-new-bank-account.component';
import { ManageBillingAddressComponent } from './components/subscription/manage-billing-address/manage-billing-address.component';
import { AddNewBillingAddressComponent } from './components/subscription/add-new-billing-address/add-new-billing-address.component';
import { ChangeCollectionTypeComponent } from './components/subscription/change-collection-type/change-collection-type.component';
import { EasyPayCreditCardComponent } from './components/subscription/change-collection-type/easy-pay-credit-card.component';
import { EasyPayBankAccountComponent } from './components/subscription/change-collection-type/easy-pay-bank-account.component';
import { PaymentHistoryComponent } from './components/subscription/payment-history/payment-history.component';
import { ActivateDigitalAccessComponent } from './components/subscription/activate-digital-access/activate-digital-access.component';
import { MakePaymentComponent } from './components/subscription/make-payment/make-payment.component';
import { ContactFormComponent } from './components/help/contact-form/contact-form.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { ScheduleVacationComponent } from './components/subscription/schedule-vacation/schedule-vacation.component';
import { FooterComponent } from './components/footer/footer.component';
import { ResponseHelpComponent } from './components/help/response-help/response-help.component';
import { ResponseSubscriptionComponent } from './components/subscription/response-subscription/response-subscription.component';
import { VacationListComponent } from './components/subscription/schedule-vacation/vacation-list/vacation-list.component';
import { ComplaintsComponent } from './components/subscription/complaints/complaints.component';
// Router
import { CONST_ROUTING } from './app.routing'; 
// Services
import { TokenInterceptor } from './services/token-interceptor.service';
import { AuthenticationService } from './authentication.service';
import { ProfileService } from './services/profile.service';
import { SubscriptionService } from './services/subscription.service';
import { SharedDataService } from './services/shared-data.service';
import { HelpService } from './services/help.service';
import { PaymentsService } from './services/payments-service';
import { AtabexDataService } from './services/atabex-data.service';
import { PaymentMethodsStaticDataService } from './services/payment-methods-static-data.service';
import { FaqsService } from './services/faqs.service';
import { ModalService } from './services/modals.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { ChangeCollectionTypeService } from './services/change-collection-type.service';
import { VacationService } from './services/vacation.service';
// Pipes
import { GenderPipe } from './pipes/gender.pipe';
import { DateOfBirthPipe } from './pipes/date-of-birth.pipe';
import { CreditCardTypePipe } from './pipes/credit-card-type.pipe';
import { ComplaintReasonsPipe } from './pipes/complaint-reasons.pipe';
import { CurrencyPipe, UpperCasePipe } from '@angular/common';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { ExpirationMonthPipe } from './pipes/expiration-month.pipe';
import { ArraySortPipe } from './pipes/array-sort.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    ProfileLoggedOutComponent,
    SubscriptionComponent,
    SubscriptionLoggedOutComponent,
    HelpComponent,
    HelpLoggedOutComponent,
    ManagePaymentMethodComponent,
    AddNewCreditCardComponent,
    AddNewBankAccountComponent,
    ManageBillingAddressComponent,
    AddNewBillingAddressComponent,
    ChangeCollectionTypeComponent,
    EasyPayCreditCardComponent,
    EasyPayBankAccountComponent,
    PaymentHistoryComponent,
    ActivateDigitalAccessComponent,
    MakePaymentComponent,
    ContactFormComponent,
    FaqsComponent,
    ScheduleVacationComponent,
    TermsAndConditionsComponent,
    FooterComponent,
    ResponseHelpComponent,
    ResponseSubscriptionComponent,
    VacationListComponent,
    ComplaintsComponent,
    GenderPipe,
    DateOfBirthPipe,
    CreditCardTypePipe,
    ComplaintReasonsPipe,
    SanitizeHtmlPipe,
    SearchPipe,
    DateFormatPipe,
    PhoneNumberPipe,
    ExpirationMonthPipe,
    ArraySortPipe  
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CONST_ROUTING
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
  CurrencyPipe,
  UpperCasePipe,
  AuthenticationService, ProfileService, SubscriptionService, SharedDataService, HelpService, PaymentsService, AtabexDataService, PaymentMethodsStaticDataService, FaqsService, ModalService, GoogleAnalyticsService, ChangeCollectionTypeService, VacationService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/app.module.ts